import { Fragment, useEffect } from "react";
import usePage from "../hooks/usePage";
import Menu from "../modules/public/menu/menu";
import Footer from "../modules/public/footer/footer";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import NewTicket from "../modules/pages/myAccount/account/newTicket";
import Swal from "sweetalert2";
import useSharedData from "../hooks/useSharedData";

const Support = () => {
  const { pageSliders, pageImage, pageText } = usePage();
  const { isAuthed } = useSharedData();

  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthed) {
      Swal.fire({
        icon: "warning",
        text: "برای ثبت تیکت نیاز به ثبت نام یا ورود دارید",
        confirmButtonColor: "gray",
        confirmButtonText: "متوجه شدم",
      }).then(() => {
        navigate("/login");
      });
    }
  }, []);

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1">
        {pageSliders}
        {pageText}

        <Container className="py-4 px-3 px-sm-3 px-md-5 mt-5 border rounded">
          <NewTicket />
        </Container>

        {pageImage}
      </main>

      <Footer />
    </Fragment>
  );
};

export default Support;
